import { ApolloError, useQuery } from '@apollo/client'
import {
  CurrentContractWithCareerPathEvaluationInProfileQuery,
  CurrentContractWithCareerPathEvaluationInProfileQueryVariables,
  Country,
} from '../../../types'
import { GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION_IN_PROFILE } from '../ContractQueries'

export default (
  employeeId: number,
  year: number,
  includeAllTargetBoni = true,
  country: Country,
): { data: CurrentContractWithCareerPathEvaluationInProfileQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<
    CurrentContractWithCareerPathEvaluationInProfileQuery,
    CurrentContractWithCareerPathEvaluationInProfileQueryVariables
  >(GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION_IN_PROFILE, {
    variables: {
      employeeId: employeeId,
      year: year,
      includeAllTargetBoni: includeAllTargetBoni,
      country,
    },
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
